const bankOpportunityFormTranslations = {
  en: {
    edit: "Edit opportunity",
    close: "Close",
    identification: "Opportunity identification",
    opportunityTitle: "Title",
    opportunityType: "Opportunity type",
    recordStatus: "Record status",
    sourceType: "Source type",
    bankCreditor: "Bank / creditor",
    externalReference: "External reference",
    deadline: "Deadline",
    location: "Location",
    country: "Country",
    district: "District",
    city: "City",
    address: "Address",
    financial: "Financial analysis",
    base_price: "Base price",
    minimum_price: "Minimum price",
    estimated_market_value: "Estimated market value",
    estimated_discount_percent: "Estimated discount %",
    analysisDueDiligence: "Analysis & due diligence",
    description: "Description",
    investment_case: "Investment case",
    risk_notes: "Risks and matters to confirm",
    verification: "Verification",
    commissionProtection: "Mandate & commission protection",
    mandateType: "Mandate type",
    commissionStatus: "Commission status",
    payingParty: "Paying party",
    feeValue: "Fee value",
    cancel: "Cancel",
    save: "Save",
    saving: "Saving…",
  },
  pt: {
    edit: "Editar oportunidade",
    close: "Fechar",
    identification: "Identificação da oportunidade",
    opportunityTitle: "Título",
    opportunityType: "Tipo de oportunidade",
    recordStatus: "Estado do registo",
    sourceType: "Tipo de fonte",
    bankCreditor: "Banco / credor",
    externalReference: "Referência externa",
    deadline: "Prazo",
    location: "Localização",
    country: "País",
    district: "Distrito",
    city: "Cidade",
    address: "Morada",
    financial: "Análise financeira",
    base_price: "Preço base",
    minimum_price: "Preço mínimo",
    estimated_market_value: "Valor de mercado estimado",
    estimated_discount_percent: "Desconto estimado %",
    analysisDueDiligence: "Análise e diligência prévia",
    description: "Descrição",
    investment_case: "Tese de investimento",
    risk_notes: "Riscos e questões a confirmar",
    verification: "Verificação",
    commissionProtection: "Mandato e proteção da comissão",
    mandateType: "Tipo de mandato",
    commissionStatus: "Estado da comissão",
    payingParty: "Parte pagadora",
    feeValue: "Valor dos honorários",
    cancel: "Cancelar",
    save: "Guardar",
    saving: "A guardar…",
  },
  zh: {
    edit: "编辑机会",
    close: "关闭",
    identification: "机会识别",
    opportunityTitle: "标题",
    opportunityType: "机会类型",
    recordStatus: "记录状态",
    sourceType: "来源类型",
    bankCreditor: "银行／债权人",
    externalReference: "外部编号",
    deadline: "截止日期",
    location: "位置",
    country: "国家",
    district: "地区",
    city: "城市",
    address: "地址",
    financial: "财务分析",
    base_price: "基础价格",
    minimum_price: "最低价格",
    estimated_market_value: "估计市场价值",
    estimated_discount_percent: "估计折扣 %",
    analysisDueDiligence: "分析与尽职调查",
    description: "说明",
    investment_case: "投资理由",
    risk_notes: "风险及待确认事项",
    verification: "核实",
    commissionProtection: "委托与佣金保护",
    mandateType: "委托类型",
    commissionStatus: "佣金状态",
    payingParty: "付款方",
    feeValue: "费用金额",
    cancel: "取消",
    save: "保存",
    saving: "正在保存…",
  },
  fr: {
    edit: "Modifier l’opportunité",
    close: "Fermer",
    identification: "Identification de l’opportunité",
    opportunityTitle: "Titre",
    opportunityType: "Type d’opportunité",
    recordStatus: "Statut du dossier",
    sourceType: "Type de source",
    bankCreditor: "Banque / créancier",
    externalReference: "Référence externe",
    deadline: "Échéance",
    location: "Localisation",
    country: "Pays",
    district: "District",
    city: "Ville",
    address: "Adresse",
    financial: "Analyse financière",
    base_price: "Prix de base",
    minimum_price: "Prix minimum",
    estimated_market_value: "Valeur de marché estimée",
    estimated_discount_percent: "Décote estimée %",
    analysisDueDiligence: "Analyse et vérifications préalables",
    description: "Description",
    investment_case: "Thèse d’investissement",
    risk_notes: "Risques et éléments à confirmer",
    verification: "Vérification",
    commissionProtection: "Mandat et protection de la commission",
    mandateType: "Type de mandat",
    commissionStatus: "Statut de la commission",
    payingParty: "Partie payante",
    feeValue: "Montant des honoraires",
    cancel: "Annuler",
    save: "Enregistrer",
    saving: "Enregistrement…",
  },
  es: {
    edit: "Editar oportunidad",
    close: "Cerrar",
    identification: "Identificación de la oportunidad",
    opportunityTitle: "Título",
    opportunityType: "Tipo de oportunidad",
    recordStatus: "Estado del registro",
    sourceType: "Tipo de fuente",
    bankCreditor: "Banco / acreedor",
    externalReference: "Referencia externa",
    deadline: "Fecha límite",
    location: "Ubicación",
    country: "País",
    district: "Distrito",
    city: "Ciudad",
    address: "Dirección",
    financial: "Análisis financiero",
    base_price: "Precio base",
    minimum_price: "Precio mínimo",
    estimated_market_value: "Valor de mercado estimado",
    estimated_discount_percent: "Descuento estimado %",
    analysisDueDiligence: "Análisis y diligencia debida",
    description: "Descripción",
    investment_case: "Tesis de inversión",
    risk_notes: "Riesgos y cuestiones por confirmar",
    verification: "Verificación",
    commissionProtection: "Mandato y protección de la comisión",
    mandateType: "Tipo de mandato",
    commissionStatus: "Estado de la comisión",
    payingParty: "Parte pagadora",
    feeValue: "Importe de honorarios",
    cancel: "Cancelar",
    save: "Guardar",
    saving: "Guardando…",
  },
  de: {
    edit: "Chance bearbeiten",
    close: "Schließen",
    identification: "Identifikation der Chance",
    opportunityTitle: "Titel",
    opportunityType: "Art der Chance",
    recordStatus: "Datensatzstatus",
    sourceType: "Quellenart",
    bankCreditor: "Bank / Gläubiger",
    externalReference: "Externe Referenz",
    deadline: "Frist",
    location: "Standort",
    country: "Land",
    district: "Bezirk",
    city: "Stadt",
    address: "Adresse",
    financial: "Finanzanalyse",
    base_price: "Ausgangspreis",
    minimum_price: "Mindestpreis",
    estimated_market_value: "Geschätzter Marktwert",
    estimated_discount_percent: "Geschätzter Abschlag %",
    analysisDueDiligence: "Analyse und Due Diligence",
    description: "Beschreibung",
    investment_case: "Investitionsthese",
    risk_notes: "Risiken und zu bestätigende Punkte",
    verification: "Prüfung",
    commissionProtection: "Mandat und Provisionsschutz",
    mandateType: "Mandatsart",
    commissionStatus: "Provisionsstatus",
    payingParty: "Zahlende Partei",
    feeValue: "Honorarwert",
    cancel: "Abbrechen",
    save: "Speichern",
    saving: "Speichern…",
  },
  it: {
    edit: "Modifica opportunità",
    close: "Chiudi",
    identification: "Identificazione dell’opportunità",
    opportunityTitle: "Titolo",
    opportunityType: "Tipo di opportunità",
    recordStatus: "Stato del record",
    sourceType: "Tipo di fonte",
    bankCreditor: "Banca / creditore",
    externalReference: "Riferimento esterno",
    deadline: "Scadenza",
    location: "Località",
    country: "Paese",
    district: "Distretto",
    city: "Città",
    address: "Indirizzo",
    financial: "Analisi finanziaria",
    base_price: "Prezzo base",
    minimum_price: "Prezzo minimo",
    estimated_market_value: "Valore di mercato stimato",
    estimated_discount_percent: "Sconto stimato %",
    analysisDueDiligence: "Analisi e due diligence",
    description: "Descrizione",
    investment_case: "Tesi d’investimento",
    risk_notes: "Rischi e aspetti da confermare",
    verification: "Verifica",
    commissionProtection: "Mandato e protezione della commissione",
    mandateType: "Tipo di mandato",
    commissionStatus: "Stato della commissione",
    payingParty: "Parte pagante",
    feeValue: "Valore degli onorari",
    cancel: "Annulla",
    save: "Salva",
    saving: "Salvataggio…",
  },
  ru: {
    edit: "Изменить возможность",
    close: "Закрыть",
    identification: "Идентификация возможности",
    opportunityTitle: "Название",
    opportunityType: "Тип возможности",
    recordStatus: "Статус записи",
    sourceType: "Тип источника",
    bankCreditor: "Банк / кредитор",
    externalReference: "Внешний номер",
    deadline: "Срок",
    location: "Местоположение",
    country: "Страна",
    district: "Район",
    city: "Город",
    address: "Адрес",
    financial: "Финансовый анализ",
    base_price: "Начальная цена",
    minimum_price: "Минимальная цена",
    estimated_market_value: "Оценочная рыночная стоимость",
    estimated_discount_percent: "Расчётная скидка %",
    analysisDueDiligence: "Анализ и комплексная проверка",
    description: "Описание",
    investment_case: "Инвестиционное обоснование",
    risk_notes: "Риски и вопросы для подтверждения",
    verification: "Проверка",
    commissionProtection: "Мандат и защита комиссии",
    mandateType: "Тип мандата",
    commissionStatus: "Статус комиссии",
    payingParty: "Плательщик",
    feeValue: "Размер вознаграждения",
    cancel: "Отмена",
    save: "Сохранить",
    saving: "Сохранение…",
  },
};

export default bankOpportunityFormTranslations;
